import * as React from 'react';

import get from 'lodash/get';

import { Alert } from '@sbv-clients/ui-shared';

import {
  apiMetricsColumns,
  ApiMetricsRowType,
  getApiMetricsRowId,
} from './api-metrics-columns';
import { BaseTable } from './base-table';

const initialState = { pagination: { paginationModel: { pageSize: 10 } } };

export function ApiMetricsGrid(props: {
  isLoading: boolean;
  isError: boolean;
  data: ApiMetricsRowType[];
  error: unknown;
}) {
  if (props.isError) {
    return (
      <Alert severity={'error'}>
        {get(props.error, 'message', 'There was an error retrieving employees')}
      </Alert>
    );
  }

  return (
    <BaseTable
      loading={props.isLoading}
      getRowId={getApiMetricsRowId}
      initialState={initialState}
      columns={apiMetricsColumns}
      rows={props.data}
    />
  );
}
